module.exports = __webpack_public_path__ + "img/know.b737fdd1.png";